import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, SplitIcon, DatabaseIcon, DownloadIcon } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const FEATURES = [{
  icon: ZapIcon,
  title: 'Generador de Volumen Industrial',
  desc: "Acceso instantáneo a la herramienta que crea 100 creativos en un click. Olvídate de esperar días por diseños o depender de la 'inspiración'. Tu semana de testing aparece de golpe, lista para subir a Meta Ads."
}, {
  icon: SplitIcon,
  title: 'El Angle-Splitter Automático',
  desc: 'No solo cambia colores. El sistema genera variantes basadas en psicología de ventas: dolor, deseo, objeción, transformación, urgencia, autoridad.'
}, {
  icon: DatabaseIcon,
  title: 'Base de Conocimiento Integrada',
  desc: 'Subí tu copy, tu branding, tu tono de voz. El sistema aprende tu marca y genera creativos que suenan como vos, manteniendo la coherencia visual y verbal.'
}, {
  icon: DownloadIcon,
  title: 'Exportación Directa a Meta Ads',
  desc: 'Descargá todos los creativos en formato optimizado para Meta Ads (4:5 y 9:16). Sin retoques, sin conversiones, sin pasos extra. De la herramienta a la campaña.'
}];
export function FeaturesSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section className="py-20 md:py-32 bg-[#0F0A16] relative" data-id="element-49">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-52">
            Todo Lo Que Incluye Tu Acceso
          </h2>
          <p className="text-purple-300/60 text-lg" data-id="element-53">
            El sistema completo para escalar tu operación creativa.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-54">
          {FEATURES.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className="glass-card p-8 rounded-2xl hover:bg-white/[0.05] transition-all group" data-id="element-55">
              <div className="flex items-start gap-6" data-id="element-56">
                <div className="flex-shrink-0" data-id="element-57">
                  <div className="w-14 h-14 bg-purple-900/20 rounded-xl flex items-center justify-center border border-purple-500/30 text-purple-400 group-hover:text-purple-300 group-hover:scale-110 transition-all duration-300" data-id="element-58">
                    <feature.icon className="w-7 h-7" data-id="element-59" />
                  </div>
                </div>
                <div data-id="element-60">
                  <div className="inline-block px-2 py-1 rounded bg-purple-500/10 border border-purple-500/20 text-purple-400 text-[10px] font-bold tracking-widest uppercase mb-3" data-id="element-61">
                    Componente #{i + 1}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-62">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed text-sm md:text-base" data-id="element-63">
                    {feature.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}